import { legacy } from '@/shared/api/client';

export const SURVEY_ID_RE = /^[A-Za-z0-9_-]{8,64}$/;
export const DEFAULT_SURVEY_MESSAGE =
  '⚠️ Queremos sua opinião, responda nossa pesquisa rapidinho. (clique no link abaixo)<br/>';
export const DEFAULT_SURVEY_LINK_TITLE = 'Responder pesquisa';
export const DEFAULT_SURVEY_BONUS_MESSAGE = 'Obrigado por ter respondido a pesquisa.';

export interface SurveySettingsPayload {
  hasSurvey: boolean;
  idSurvey?: string;
  messageSurvey?: string;
  titleLinkSurvey?: string;
  /** Texto do extrato quando a resposta bonifica. */
  mensagemBonificacaoNPS?: string;
  /** Selos, pontos ou R$ de cashback (conforme o programa da loja). 0 = não bonifica. */
  qtdeBonificarNPS?: number;
}

/** Persiste a pesquisa NPS da loja (PUT /passbook/:id/survey). */
export async function updateSurveySettings(
  idPassbook: string,
  payload: SurveySettingsPayload,
): Promise<void> {
  await legacy.put<{ ok: boolean }>(`/passbook/${idPassbook}/survey`, payload, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
}
